export default __webpack_public_path__ + "static/media/footer-logo-facebook.58e976b0.svg";